import React, { useState, useEffect } from 'react';

// Simple Kanban without external libs. columns: open, in_progress, waiting, closed
export default function KanbanBoard({ apiBase='/api/tickets_advanced.php', onTicketClick, token }) {
  const [columns, setColumns] = useState({ open: [], in_progress: [], waiting: [], closed: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchAll(); }, []);

  async function fetchAll() {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}?page_size=1000`);
      const j = await res.json();
      const arr = j.tickets || [];
      const cols = { open: [], in_progress: [], waiting: [], closed: [] };
      arr.forEach(t => {
        const s = t.status || 'open';
        if (!cols[s]) cols[s] = [];
        cols[s].push(t);
      });
      setColumns(cols);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  }

  function onDragStart(e, ticket, from) {
    e.dataTransfer.setData('application/json', JSON.stringify({ id: ticket.id, from }));
  }
  function onDrop(e, to) {
    e.preventDefault();
    const d = e.dataTransfer.getData('application/json');
    if (!d) return;
    const obj = JSON.parse(d);
    const id = obj.id;
    // optimistic update
    moveTicketLocal(id, obj.from, to);
    // send update to backend
    fetch(`${apiBase}?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': token ? ('Bearer ' + token) : '' },
      body: JSON.stringify({ status: to })
    }).then(r=>r.json()).then(()=>{}).catch(err=>{ console.error(err); fetchAll(); });
  }
  function allow(e){ e.preventDefault(); }

  function moveTicketLocal(id, from, to) {
    setColumns(prev=>{
      const src = [...prev[from]];
      const idx = src.findIndex(t=>t.id===id);
      if (idx<0) return prev;
      const [item] = src.splice(idx,1);
      const dst = [...prev[to], item];
      return {...prev, [from]: src, [to]: dst};
    });
  }

  return (
    <div>
      <div className="flex gap-3">
        {['open','in_progress','waiting','closed'].map(col => (
          <div key={col} className="flex-1 p-2 bg-gray-50 rounded" onDragOver={allow} onDrop={e=>onDrop(e,col)}>
            <h4 className="font-semibold capitalize">{col.replace('_',' ')}</h4>
            <div className="space-y-2 mt-2">
              {(columns[col]||[]).map(t => (
                <div key={t.id} draggable onDragStart={e=>onDragStart(e,t,col)} className="p-2 bg-white rounded shadow-sm cursor-move" onClick={()=>onTicketClick && onTicketClick(t.id)}>
                  <div className="text-sm font-medium">{t.title}</div>
                  <div className="text-xs text-gray-500">{t.requester_email}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {loading && <div className="text-sm mt-2">A carregar Kanban...</div>}
    </div>
  );
}
